import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

window.addEventListener("load", () => {
  const loader = document.getElementById("loader");
  loader.style.opacity = "0";
  loader.style.transition = "opacity 0.5s ease";

  // Supprime le loader après la transition pour libérer le DOM
  setTimeout(() => {
    loader.style.display = "none";
  }, 500);
});

document.addEventListener("DOMContentLoaded", () => {
  const video = document.querySelector(".animation-joana");
  const fallback = document.querySelector(".animation-joana-fallback");

  // On cache fallback par défaut
  fallback.style.display = "none";

  const userAgent = navigator.userAgent.toLowerCase();
  const isSafari =
    userAgent.includes("safari") && !userAgent.includes("chrome");
  const isFirefox = userAgent.includes("firefox");
  const isChromeOrEdge =
    (userAgent.includes("chrome") || userAgent.includes("edg")) && !isSafari;

  // Fonction pour afficher la bonne source
  function setupVideo() {
    if (isSafari) {
      // Safari → MOV
      const movSrc = video.querySelector('source[type="video/quicktime"]');
      const webmSrc = video.querySelector('source[type="video/webm"]');
      if (webmSrc) webmSrc.remove();

      if (movSrc && video.canPlayType("video/quicktime") !== "") {
        video.style.display = "block";
        fallback.style.display = "none";
        video.load();
        video.play().catch(() => {
          video.style.display = "none";
          fallback.style.display = "block";
        });
      } else {
        video.style.display = "none";
        fallback.style.display = "block";
      }
    } else if (isChromeOrEdge) {
      // Chrome/Edge → WebM
      const webmSrc = video.querySelector('source[type="video/webm"]');
      const movSrc = video.querySelector('source[type="video/quicktime"]');
      if (movSrc) movSrc.remove();

      if (
        webmSrc &&
        video.canPlayType('video/webm; codecs="vp8, vorbis"') !== ""
      ) {
        video.style.display = "block";
        fallback.style.display = "none";
        video.load();
        video.play().catch(() => {
          video.style.display = "none";
          fallback.style.display = "block";
        });
      } else {
        video.style.display = "none";
        fallback.style.display = "block";
      }
    } else {
      // Firefox, IE, etc → PNG fallback
      video.style.display = "none";
      fallback.style.display = "block";
    }
  }

  setupVideo();
});

document.addEventListener("DOMContentLoaded", () => {
  // -----------------------------
  // 1️⃣ CURSEUR PERSONNALISÉ
  // -----------------------------
  const cursor = document.querySelector(".custom-cursor");
  if (cursor) {
    document.addEventListener("mousemove", (e) => {
      cursor.style.top = e.clientY + "px";
      cursor.style.left = e.clientX + "px";
    });

    const clickableElements = document.querySelectorAll(
      "a, button, .cta-section, .filter-item, #back-arrow"
    );
    clickableElements.forEach((el) => {
      el.addEventListener("mouseenter", () => cursor.classList.add("active"));
      el.addEventListener("mouseleave", () =>
        cursor.classList.remove("active")
      );
    });
  }

  // -----------------------------
  // 2️⃣ BULLES SUR LES PROJETS
  // -----------------------------
  document.querySelectorAll(".cta-section").forEach((section) => {
    const bubble = section.querySelector(".hover-bubble");
    if (!bubble) return;

    let mouseX = 0,
      mouseY = 0,
      currentX = 0,
      currentY = 0;
    const delay = 0.1,
      offsetX = -50,
      offsetY = 40;

    function animateBubble() {
      currentX += (mouseX - currentX) * delay;
      currentY += (mouseY - currentY) * delay;
      bubble.style.transform = `translate(${currentX}px, ${currentY}px) translate(-50%, -50%)`;
      requestAnimationFrame(animateBubble);
    }
    animateBubble();

    section.addEventListener("mousemove", (e) => {
      mouseX = e.clientX + offsetX;
      mouseY = e.clientY + offsetY;
    });

    section.addEventListener("mouseenter", (e) => {
      mouseX = e.clientX + offsetX;
      mouseY = e.clientY + offsetY;
      currentX = mouseX;
      currentY = mouseY;
      bubble.style.opacity = 1;
    });

    section.addEventListener("mouseleave", () => {
      bubble.style.opacity = 0;
    });
  });

  // -----------------------------
  // 3️⃣ FILTRE PROJETS
  // -----------------------------
  const filterItems = document.querySelectorAll(".filter-item");
  const projectLinks = document.querySelectorAll(".AB-link, .project-link"); // tous les wrappers <a>

  filterItems.forEach((item) => {
    item.addEventListener("click", () => {
      // sélection visuelle
      filterItems.forEach((i) => i.classList.remove("selected"));
      item.classList.add("selected");

      const filter = item.dataset.filter;

      projectLinks.forEach((link) => {
        const project = link.querySelector(".project");
        const category = project.dataset.category;

        // Affichage correct
        link.style.display =
          filter === "tout" || category === filter ? "block" : "none";
      });
    });
  });

  // -----------------------------
  // 4️⃣ NAVIGATION QUI DISPARAIT AU SCROLL
  // -----------------------------
  const nav = document.querySelector(".nav");
  let lastScroll = 0;
  window.addEventListener("scroll", () => {
    const currentScroll = window.scrollY;
    if (currentScroll <= 50) {
      nav?.classList.remove("hide");
      return;
    }
    if (currentScroll > lastScroll) {
      nav?.classList.add("hide");
    } else {
      nav?.classList.remove("hide");
    }
    lastScroll = currentScroll;
  });
}); // FIN DOMContentLoaded

// -----------------------------
// 5️⃣ FLECHE RETOUR
// -----------------------------
const backArrow = document.getElementById("back-arrow");
if (backArrow) {
  backArrow.style.cursor = "pointer";
  backArrow.addEventListener("click", () => history.back());
}

// -----------------------------
// 6️⃣ LIGHTBOX GALERIE
// -----------------------------
const lightbox = GLightbox({
  selector: ".glightbox",
  loop: true,
  zoomable: true,
  touchNavigation: true,
});

// -----------------------------
// 7️⃣ IMAGE COLORIMÉTRIE
// -----------------------------
document.querySelectorAll(".video-colo-wrapper").forEach((div) => {
  const hoverImg = div.querySelector(".hover-img");
  const baseImg = div.querySelector(".base-img");

  div.addEventListener("mouseenter", () => {
    baseImg.style.opacity = 0;
  });

  div.addEventListener("mouseleave", () => {
    baseImg.style.opacity = 1;
  });
});

// -----------------------------
// 6️⃣ YOUTUBE PLAYER + CONTROLES + FULLSCREEN
// -----------------------------
let tag = document.createElement("script");
tag.src = "https://www.youtube.com/iframe_api";
document.body.appendChild(tag);

const playSVG = {
  play: `<svg width="29" height="32" viewBox="0 0 29 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 28.7305V2.85156C0 1.88802 0.240885 1.17188 0.722656 0.703125C1.21745 0.234375 1.8099 0 2.5 0C3.08594 0 3.67839 0.169271 4.27734 0.507812L25.957 13.1836C26.7513 13.6263 27.3112 14.043 27.6367 14.4336C27.9622 14.8242 28.125 15.2799 28.125 15.8008C28.125 16.3216 27.9622 16.7773 27.6367 17.1679C27.3112 17.5586 26.7513 17.9753 25.957 18.4179L4.27734 31.0938C3.67839 31.4323 3.08594 31.6016 2.5 31.6016C1.8099 31.6016 1.21745 31.3672 0.722656 30.8984C0.240885 30.4297 0 29.7135 0 28.7305Z" fill="white"/></svg>`,
  pause: `<svg width="29" height="32" viewBox="0 0 29 32" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="11" height="32" rx="2" fill="white"/><rect x="18" width="11" height="32" rx="2" fill="white"/></svg>`,
};

const muteSVG = {
  on: `<svg width="51" height="37" viewBox="0 0 51 37" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M20.0781 34.668C19.6224 34.668 19.1927 34.5703 18.7891 34.375C18.3984 34.1927 17.9753 33.8932 17.5195 33.4766L9.72656 26.0938C9.6224 25.9766 9.47266 25.918 9.27734 25.918H4.02344C2.72135 25.918 1.72526 25.5664 1.03516 24.8633C0.345052 24.1602 0 23.112 0 21.7188V14.8438C0 13.4635 0.345052 12.4154 1.03516 11.6992C1.72526 10.9831 2.72135 10.625 4.02344 10.625H9.27734C9.47266 10.625 9.6224 10.5729 9.72656 10.4688L17.5195 3.16406C18.0143 2.69531 18.444 2.35677 18.8086 2.14844C19.1862 1.9401 19.6029 1.83594 20.0586 1.83594C20.7227 1.83594 21.263 2.0638 21.6797 2.51953C22.1094 2.97526 22.3242 3.52214 22.3242 4.16016V32.4414C22.3242 33.0924 22.1094 33.6263 21.6797 34.043C21.263 34.4596 20.7292 34.668 20.0781 34.668ZM28.9062 26.2891C28.4896 26.0026 28.2487 25.6315 28.1836 25.1758C28.1185 24.7201 28.2487 24.2643 28.5742 23.8086C29.0951 23.0664 29.4987 22.2135 29.7852 21.25C30.0716 20.2865 30.2148 19.2839 30.2148 18.2422C30.2148 17.2005 30.0716 16.1979 29.7852 15.2344C29.4987 14.2578 29.0951 13.3984 28.5742 12.6562C28.2487 12.2135 28.1185 11.7643 28.1836 11.3086C28.2487 10.8529 28.4896 10.4818 28.9062 10.1953C29.2578 9.94792 29.6419 9.86979 30.0586 9.96094C30.4753 10.0391 30.8138 10.2604 31.0742 10.625C31.8164 11.6146 32.3893 12.7734 32.793 14.1016C33.1966 15.4167 33.3984 16.7969 33.3984 18.2422C33.3984 19.6875 33.1966 21.0742 32.793 22.4023C32.3893 23.7305 31.8164 24.8763 31.0742 25.8398C30.8138 26.2174 30.4753 26.4518 30.0586 26.543C29.6419 26.6211 29.2578 26.5365 28.9062 26.2891ZM36.0352 31.1719C35.6445 30.9115 35.4232 30.5664 35.3711 30.1367C35.319 29.694 35.4362 29.2513 35.7227 28.8086C36.7122 27.3763 37.4805 25.7487 38.0273 23.9258C38.5872 22.0898 38.8672 20.1953 38.8672 18.2422C38.8672 16.2891 38.5938 14.3945 38.0469 12.5586C37.5 10.7227 36.7253 9.09505 35.7227 7.67578C35.4362 7.23307 35.319 6.79688 35.3711 6.36719C35.4232 5.92448 35.6445 5.57292 36.0352 5.3125C36.4128 5.05208 36.8099 4.96745 37.2266 5.05859C37.6562 5.14974 38.0013 5.39062 38.2617 5.78125C39.4727 7.42188 40.4102 9.33594 41.0742 11.5234C41.7383 13.6979 42.0703 15.9375 42.0703 18.2422C42.0703 20.5469 41.7318 22.7865 41.0547 24.9609C40.3906 27.1224 39.4596 29.0365 38.2617 30.7031C38.0013 31.0938 37.6562 31.3346 37.2266 31.4258C36.8099 31.5039 36.4128 31.4193 36.0352 31.1719ZM43.2227 36.1133C42.832 35.8529 42.6107 35.5013 42.5586 35.0586C42.5065 34.6159 42.6237 34.1797 42.9102 33.75C43.8477 32.3438 44.6615 30.8203 45.3516 29.1797C46.0417 27.526 46.5755 25.7812 46.9531 23.9453C47.3307 22.1094 47.5195 20.2083 47.5195 18.2422C47.5195 16.276 47.3307 14.3815 46.9531 12.5586C46.5755 10.7227 46.0417 8.98438 45.3516 7.34375C44.6615 5.70312 43.8477 4.16667 42.9102 2.73438C42.6237 2.30469 42.5065 1.86849 42.5586 1.42578C42.6107 0.983073 42.832 0.63151 43.2227 0.371094C43.6003 0.123698 44.0039 0.0455729 44.4336 0.136719C44.8633 0.227865 45.2214 0.481771 45.5078 0.898438C46.5625 2.48698 47.4805 4.20573 48.2617 6.05469C49.043 7.89062 49.6419 9.83724 50.0586 11.8945C50.4753 13.9388 50.6836 16.0547 50.6836 18.2422C50.6836 20.4427 50.4753 22.5651 50.0586 24.6094C49.6419 26.6536 49.043 28.6003 48.2617 30.4492C47.4935 32.2852 46.5755 34.0039 45.5078 35.6055C45.2214 36.0091 44.8633 36.2565 44.4336 36.3477C44.0039 36.4388 43.6003 36.3607 43.2227 36.1133Z" fill="white"/>
</svg>

`,
  off: `<svg width="35" height="36" viewBox="0 0 35 36" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.61719 24.082C6.3151 24.082 5.33203 23.7435 4.66797 23.0664C4.01693 22.3893 3.69141 21.3542 3.69141 19.9609V12.9297C3.69141 11.6276 3.98438 10.651 4.57031 10L25.8594 31.2695C25.6901 31.8034 25.4232 32.194 25.0586 32.4414C24.694 32.7018 24.2643 32.832 23.7695 32.832C23.3138 32.832 22.8841 32.7344 22.4805 32.5391C22.0898 32.3568 21.6667 32.0573 21.2109 31.6406L13.3203 24.2578C13.1901 24.1406 13.0404 24.082 12.8711 24.082H7.61719ZM26.0156 21.0742L13.125 8.22266H13.6328C13.724 8.22266 13.8216 8.17708 13.9258 8.08594L21.2109 1.32812C21.7057 0.872396 22.1354 0.540365 22.5 0.332031C22.8646 0.110677 23.2747 0 23.7305 0C24.3945 0 24.9414 0.227865 25.3711 0.683594C25.8008 1.13932 26.0156 1.6862 26.0156 2.32422V21.0742ZM32.4414 34.707L0.410156 2.71484C0.136719 2.45443 0 2.11589 0 1.69922C0 1.28255 0.136719 0.9375 0.410156 0.664062C0.696615 0.390625 1.04167 0.253906 1.44531 0.253906C1.86198 0.253906 2.20703 0.390625 2.48047 0.664062L34.4922 32.6367C34.7656 32.9362 34.9023 33.2812 34.9023 33.6719C34.9023 34.0755 34.7656 34.4206 34.4922 34.707C34.2057 34.9935 33.8607 35.1367 33.457 35.1367C33.0534 35.1367 32.7148 34.9935 32.4414 34.707Z" fill="white"/>
</svg>
`,
};

const videoWrappers = document.querySelectorAll(".project-detail-cover.vid");

window.onYouTubeIframeAPIReady = function () {
  videoWrappers.forEach((wrapper) => {
    const playerEl = wrapper.querySelector(".youtube-player");
    const playBtn = wrapper.querySelector(".play-btn");
    const muteBtn = wrapper.querySelector(".mute-btn");
    const timeline = wrapper.querySelector(".timeline");
    const progressEl = timeline?.querySelector(".progress");
    let handle = timeline?.querySelector(".handle"); // le rond draggable
    const fullscreenOverlay = wrapper.querySelector(".fullscreen-overlay");
    const hoverBubble = wrapper.querySelector(".hover-bubble");
    const videoControls = wrapper.querySelector(".video-controls");
    const videoId = wrapper.dataset.videoId;

    let player;
    let hideControlsTimeout;
    let wasMutedBeforeFullscreen = true;
    let lastMouseMoveTime = Date.now();

    // =========================
    // Créer le handle si pas présent
    // =========================
    if (timeline && !handle) {
      handle = document.createElement("div");
      handle.className = "handle";
      timeline.appendChild(handle);
    }

    // =========================
    // YouTube Player
    // =========================
    player = new YT.Player(playerEl, {
      videoId,
      playerVars: {
        autoplay: 1,
        controls: 0,
        modestbranding: 1,
        rel: 0,
        loop: 1,
        playlist: videoId,
        mute: 1,
      },
      events: {
        onReady: () => {
          playBtn.innerHTML = playSVG.pause;
          muteBtn.innerHTML = muteSVG.off;

          // =========================
          // Timeline animation + handle
          // =========================
          const animateTimeline = () => {
            if (!player) return;
            const duration = player.getDuration() || 1;
            const current = player.getCurrentTime() || 0;
            const percent = (current / duration) * 100;
            if (progressEl) progressEl.style.width = `${percent}%`;
            if (handle) handle.style.left = `${percent}%`;
            requestAnimationFrame(animateTimeline);
          };
          animateTimeline();

          // =========================
          // Timeline interaction (click + drag)
          // =========================
          if (timeline && handle) {
            const seekVideo = (e) => {
              const rect = timeline.getBoundingClientRect();
              let x = e.clientX - rect.left;
              x = Math.max(0, Math.min(rect.width, x));
              const percent = x / rect.width;
              player.seekTo(player.getDuration() * percent, true);
            };

            timeline.addEventListener("click", (e) => seekVideo(e));

            let isDragging = false;
            handle.addEventListener("mousedown", () => (isDragging = true));
            document.addEventListener("mouseup", () => (isDragging = false));
            document.addEventListener("mousemove", (e) => {
              if (isDragging) seekVideo(e);
            });
          }

          // =========================
          // Play / Pause
          // =========================
          playBtn.addEventListener("click", () => {
            if (player.getPlayerState() === YT.PlayerState.PLAYING) {
              player.pauseVideo();
              playBtn.innerHTML = playSVG.play;
            } else {
              player.playVideo();
              playBtn.innerHTML = playSVG.pause;
            }
          });

          // =========================
          // Mute / Unmute
          // =========================
          muteBtn.addEventListener("click", () => {
            if (player.isMuted()) {
              player.unMute();
              muteBtn.innerHTML = muteSVG.on;
            } else {
              player.mute();
              muteBtn.innerHTML = muteSVG.off;
            }
          });

          // =========================
          // Apparition / disparition contrôles
          // =========================
          const showControls = () => {
            if (videoControls) {
              videoControls.style.opacity = "1";
              videoControls.style.pointerEvents = "auto";
            }
            if (cursor) cursor.style.display = "block";
          };

          const hideControls = () => {
            if (videoControls) {
              videoControls.style.opacity = "0";
              videoControls.style.pointerEvents = "none";
            }
            if (document.fullscreenElement && cursor)
              cursor.style.display = "none";
          };

          const resetControlsTimer = () => {
            lastMouseMoveTime = Date.now();
            showControls();
            clearTimeout(hideControlsTimeout);
            hideControlsTimeout = setTimeout(hideControls, 3000);
          };

          // Vérifie l’inactivité toutes les 500ms
          const checkInactivity = () => {
            if (Date.now() - lastMouseMoveTime > 3000) hideControls();
            requestAnimationFrame(checkInactivity);
          };
          checkInactivity();

          // Bouge souris = réapparition + reset timer
          wrapper.addEventListener("mousemove", () => resetControlsTimer());

          // Hover sur les contrôles = pas de disparition
          if (videoControls) {
            videoControls.addEventListener("mouseenter", () =>
              clearTimeout(hideControlsTimeout)
            );
            videoControls.addEventListener("mouseleave", () =>
              resetControlsTimer()
            );
          }

          // Initial
          resetControlsTimer();
        },
      },
    });

    // =========================
    // Fullscreen
    // =========================
    if (fullscreenOverlay) {
      fullscreenOverlay.addEventListener("click", () => {
        if (!document.fullscreenElement) wrapper.requestFullscreen?.();
        else document.exitFullscreen?.();
      });

      document.addEventListener("fullscreenchange", () => {
        const isFull = !!document.fullscreenElement;

        if (isFull && player) {
          wasMutedBeforeFullscreen = player.isMuted();
          if (player.isMuted()) {
            player.unMute();
            muteBtn.innerHTML = muteSVG.on;
          }
          if (hoverBubble) hoverBubble.style.display = "none";
        } else if (player) {
          if (wasMutedBeforeFullscreen) {
            player.mute();
            muteBtn.innerHTML = muteSVG.off;
          }
          if (hoverBubble) hoverBubble.style.display = "block";
          if (cursor) cursor.style.display = "block";
        }
      });
    }
  });
};

// =========================
// Croix retour
// =========================
const croixButton = document.querySelector(".burger-link");
if (croixButton) {
  croixButton.addEventListener("click", (e) => {
    e.preventDefault();
    window.location.href = document.referrer || "index.html";
  });
}
